import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { OrderConfirmationPageContext } from "@insite/content-library/Pages/OrderConfirmationPage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { css } from "styled-components";

export interface OrderConfirmationPageContainerStyles {
    container?: GridContainerProps;
    headerGridItem?: GridItemProps;
    accountSignUpGridItem?: GridItemProps;
    orderInformationGridItem?: GridItemProps;
    orderTotalGridItem?: GridItemProps;
    productListGridItem?: GridItemProps;
    orderTotalGridItemNew?: InjectableCss;
}

export const orderConfirmationPageContainerStyles: OrderConfirmationPageContainerStyles = {
    headerGridItem: {
        css: css`
            @media print {
                width: 100%;
                border-top: none !important;
            }
            padding-bottom: .9375rem;
            border-top: 10px solid #f7f9fa;
            background-color: #fff;

            &.confirmation-footer {
                border-top: none;
                order: 5;

                .title-container {
                    display: none;
                }
                > div > div > div {
                    margin-bottom: -1.25rem;
                }
                .button-container {
                    padding-bottom: 11.875rem;
                    position: relative;
                    &:after {
                        content: "";
                        border-bottom: 1px solid #C2D1D9;
                        width: 80%;
                        position: absolute;
                        left: 40%;
                        margin-left: -30%;
                        top: 5.75rem;

                        @media screen and (max-width: 767px) {
                            width: 90%;
                            left: 45%;
                            margin-left: -39%;
                        }
                    }

                    @media print {
                        padding-bottom: 0;

                        &:after {
                            content: none;
                        }
                    }
                }

                .button-wrapper {
                    @media print {
                        .button-wrapper {
                            background: none;
                        }
                        padding-bottom: 0;
                    }
                }

                .continue-container {
                    position: absolute;
                    top: 4.625rem;
                    left: 50%;
                    width: 27.75rem;
                    margin-left: -13.875rem;
                    background: #f7f9fa;
                    z-index: 9;

                    .continue-btn {
                        border-width: .0625rem;
                    }
                    
                    @media screen and (min-width: 768px) and (max-width: 990px) {
                        width: 22.5rem;
                        margin-left: -11.25rem;
                    }

                    @media screen and (max-width: 767px) {
                        width: 17.25rem;
                        margin-left: -8.5rem;
                    }
                }

                @media print {
                    display: none !important;
                }
            }

            &.confirmation-header {
                .continue-btn {
                    display: none;
                }
            }
        `,
        width: 12,
    },
    accountSignUpGridItem: {
        css: css`
            order: 2;
            display: none;
            background-color: #fff;
        `,
        width: 12,
    },
    orderInformationGridItem: {
        css: css`
            background-color: #fff;
            @media (min-width: 768px) {
                padding-left: 2.8125rem; 
                padding-right: 2.8125rem; 
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                    css`
                        order: 2;
                    `,
                ])}
        `,
        width: [12, 12, 12, 12, 12],
    },
    orderTotalGridItem: {
        css: css`
            margin-left: auto !important;
            padding-top: 0 !important;
            background-color: #fff;
            padding-bottom: 1.25rem;
            > div {
                > div {
                    background: #fff;
                    padding: 0;
                }
            }
            .cart-total {
                > div {
                    > div {
                        padding-bottom: 0 !important;
                        line-height: 1.2;
                        
                        @media print {
                            &:nth-of-type(even) {
                                text-align: right;
                            }
                        }
                    }
                }

                .order-total {
                    padding-top: 1.25rem;
                    span {
                        color: #333F48;
                        font-size: 1.25rem;
                        font-weight: 500;
                        letter-spacing: -.024rem;
                        line-height: 1.4375rem;
                    }
                }

                .order-total-value {
                    padding-top: 1.25rem;
                    span {
                        color: #C63527;
                        font-size: 1.375rem;
                        font-weight: bold;
                        letter-spacing: -.026rem;
                        line-height: 1.4375rem;

                        @media print {
                            text-align: right;
                        }
                    }
                }

                .order-subtotal {
                    color: #535E64;
                    font-size: 1rem;
                    font-weight: 500;
                    letter-spacing: -.019rem;
                    line-height: 1.4375rem
                }

                .order-subtotal-value {
                    color: #35414B;
                    font-size: 1.25rem;
                    font-weight: bold;
                    letter-spacing: -.024rem;
                    line-height: 1.4375rem;

                    @media print {
                        text-align: right;
                    }
                }

                .order-label {
                    color: #535E64;
                    font-size: 1rem;
                    font-weight: 500;
                    letter-spacing: -.019rem;
                    line-height: 1.4375rem
                }

                .order-value {
                    color: #333F48;
                    font-size: 1.25rem;
                    letter-spacing: -.024rem;
                    line-height: 1.4375rem;
                    text-align: right;

                    @media print {
                        text-align: right;
                    }
                }


            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        order: 5;
                    `,
                    css`
                        order: 5;
                    `,
                    css`
                        order: 5;
                    `,
                    css`
                        order: 5;
                    `,
                    css`
                        order: 5;
                    `,
                ])}

            @media print {
                float: right;
            }

            @media (min-width: 768px) {
                padding-left: 2.8125rem; 
                padding-right: 2.8125rem;
                padding-bottom: 2.8125rem; 
            }
        `,
        width: [12, 12, 6, 5, 5],
    },
    orderTotalGridItemNew: {
        css: css`
            margin-left: auto;
            background-color: #fff;
        `,
    },
    productListGridItem: {
        css: css`
            order: 4;
            background-color: #fff;

            @media (min-width: 768px) {
                padding-left: 2.8125rem; 
                padding-right: 2.8125rem; 
            }
        `,
        width: [12, 12, 12, 12, 12],
    },
    container: {
        css: css`
            background-color: #fff;

            > div {
                background-color: #fff;
            }
        `
    }
};

const styles = orderConfirmationPageContainerStyles;

const OrderConfirmationPageContainer = ({ id }: WidgetProps) => {
    return (
        <GridContainer {...styles.container} >
            <GridItem {...styles.headerGridItem} className="confirmation-header">
                <Zone zoneName="Content00" contentId={id} />
            </GridItem>
            <GridItem {...styles.orderInformationGridItem}>
                <Zone zoneName="Content01" contentId={id} />
            </GridItem>
            <GridItem {...styles.productListGridItem}>
                <Zone zoneName="Content03" contentId={id} />
            </GridItem>
            <GridItem {...styles.orderTotalGridItem}>
                <Zone zoneName="Content02" contentId={id} />
            </GridItem>
            <GridItem {...styles.headerGridItem} className="confirmation-footer">
                <Zone zoneName="Content00" contentId={id} />
            </GridItem>
            <GridItem {...styles.accountSignUpGridItem}>
                <Zone zoneName="Content04" contentId={id} />
            </GridItem>
            
        </GridContainer>
    );
};

const widgetModule: WidgetModule = {
    component: OrderConfirmationPageContainer,
    definition: {
        displayName: "Page Container",
        group: "Order Confirmation",
        allowedContexts: [OrderConfirmationPageContext],
    },
};
export default widgetModule;
